import { Pipe, PipeTransform } from '@angular/core';

import { PackagingFormat } from '@rds/rds-packaging-ts';

/**
 * Gets the count of selected formats
 * @author Will Davis <will.davis@mtna.us>
 */
@Pipe({
  name: 'rdsFormatSelectedCount',
})
export class RdsFormatSelectedCountPipe implements PipeTransform {
  transform(selected: Array<PackagingFormat> | null | undefined, format: PackagingFormat): number {
    if (!selected?.length || !format) {
      return 0;
    }
    return selected.filter((f) => f.id === format.id).length;
  }
}
